import {useQuery} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {openBankingApi} from '../api';

export const bankProvidersKeys = {
  all: () => ['bank-providers'] as const
};

export function useBankProvidersQuery() {
  const client = useApiClient();
  return useQuery({
    queryKey: bankProvidersKeys.all(),
    queryFn: () => openBankingApi.fetchProviders(client),
    select: response => response.data,
    staleTime: 60 * 60 * 1000
  });
}
